import React, { Component } from 'react';

class IconTicketLoading extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25">
                <path fill="#EF5DA8" d="M6.673 12.5a5.915 5.915 0 015.915-5.92c.18 0 .36 0 .537.025v-2.33c-.207-.025-.415-.025-.625-.025A8.25 8.25 0 006 17.587l1.695-1.75A5.883 5.883 0 016.673 12.5z"
                ></path>
                <path fill="#F9F9F9" d="M12.5 20.75a8.25 8.25 0 00.625-16.475v2.33a5.913 5.913 0 11-5.422 9.225l-1.695 1.75a8.23 8.23 0 006.492 3.17z"
                ></path>
            </svg>
        );
    }
}

export default IconTicketLoading;